<template>
  <div style="padding:20px;">
    <el-row style="margin-bottom:15px;">
      <el-button type="primary" @click="getData" icon="refresh">刷新</el-button>
      <el-button type="primary" v-if="isAddEditPower" @click="$refs.roleEdit.toAdd()" icon="circle-plus-filled">新建角色</el-button>
      <el-button type="primary" v-if="isOrgSuper" @click="$refs.transferSuper.show()" icon="promotion">转让主管理员</el-button>
    </el-row>
    <el-table :data="roles" tooltip-effect="dark" border stripe height="calc(100vh - 170px)" v-loading="loading"
      row-key="id" default-expand-all :tree-props="{'children': 'roleUsers'}">
      <el-table-column label="序号" width="55" type="index"></el-table-column>
      <el-table-column prop="name" label="名称" :min-width="200" show-overflow-tooltip>
        <template #="{row}">
            <el-tag size="small" v-if="row.userId" type="danger">人员</el-tag>
            <el-tag size="small" v-else>角色</el-tag>
          <span style="margin-left: 5px;">{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed">
      </el-table-column>
      <el-table-column label="启用">
        <template #default="{row}">
          <el-switch v-if="row.isEffective !== undefined" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" v-model="row.isEffective"
            inline-prompt :loading="row.loading" @change="isEffectiveChange(row)" :disabled="!isAddEditPower"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" v-if="isAddUserPower || isAddEditPower || isDeletePower">
        <template #default="{row}">
          <div v-if="!row.userId && row.isEffective !== undefined">
            <!-- <el-button type="text" v-if="isUserManagerPower" @click="toRoleUser(row)">人员管理</el-button> -->
            <el-button type="text" v-if="isAddUserPower" @click="toAddRoleUser(row)">添加人员</el-button>
            <el-button type="text" v-if="isAddEditPower" @click="$refs.roleEdit.toEdit(row)">编辑</el-button>
            <el-button type="text" v-if="isDeletePower && row.type !='13'" @click="toDeleteRole(row.id)" style="color:red;">删除</el-button>
          </div>
          <el-button v-if="isDeleteUserPower && row.userId " type="text" style="color: red" @click="toDeleteRoleUser(row.id)" class="btn-not-high-padding"
                  size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <!-- <role-user ref="roleUser" /> -->
  <role-edit ref="roleEdit" @get-data="getData" :orgs="orgs" />
  <user-add :role="role" ref="userAdd" @get-data="getData" />
  <transfer-super v-if="isOrgSuper" ref="transferSuper" />
</template>

<script>
import { defineComponent } from 'vue';
import { deleteEnterpriseRole, deleteUserRoleById, getCurrRoleList, getUserListByRoleId, updateRoleIsEffectiveById } from '@/api/enterprise/role';
// import RoleUser from './User.vue';
import RoleEdit from './RoleEdit.vue';
import UserAdd from './UserAdd.vue'
import TransferSuper from './TransferSuper.vue';
import { getCurrOrgWidthSub } from '@/api/enterprise';
import { arrToValueKeyObj } from '@/utils/common';
import { mapGetters } from 'vuex'

import { isHavePower } from '@/utils/common';
export default defineComponent({
  components: { RoleEdit, UserAdd, TransferSuper },
  data() {
    return {
      loading: false,
      roles: [],
      role: {},
      tableColumns: [
        { prop: 'orgName', label: '公司', minWidth: 150 },
        { prop: 'sex', label: '性别', minWidth: 150 },
        { prop: 'phone', label: '手机号', minWidth: 150 }
      ],
      orgs: [], // 企业及其子企业列表
      roleUserTableColumns: [
        { prop: 'name', label: '姓名', minWidth: 250 },
        { prop: 'sex', label: '性别' },
        { prop: 'phone', label: '手机号' },
      ],
    }
  },
  computed: {
    ...mapGetters(['isOrgSuper']),
    orgObjName() { // 以id为键，企业名为值
      return arrToValueKeyObj(this.orgs, 'id', 'fullName');
    },
    isAddEditPower() { // 添加/修改权限
      return isHavePower('99675173459853638');
    },
    isDeletePower() { // 删除权限
      return isHavePower('99675173459853639');
    },
    isUserManagerPower() { // 人员管理权限
      return isHavePower('99675173459853640');
    },
    isAddUserPower() { // 添加人员权限
      return isHavePower('99675173459853641');
    },
    isDeleteUserPower() { // 删除人员权限
      return isHavePower('99675173459853642');
    }
  },
  mounted() {
    this.getData();
    this.getOrgs();
  },
  methods: {
    getData() {
      this.loading = true;
      getCurrRoleList().then(({data}) => {
        this.roles = data.data;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    isEffectiveChange(row) {
      row.isEffective = row.isEffective ? 0 : 1;
      row.loading = true;

      this.$confirm('确定要改变角色的启用禁用状态', '提示').then(_ => {
        updateRoleIsEffectiveById(row.isEffective ? 0 : 1, row.id).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
          row.loading = false;
        }).catch(_ => row.loading = false);
      }).catch(err => {
        console.log('err:', err)
        row.loading = false;
      });
    },
    toRoleUser(role) {
      this.$refs.roleUser.show(role);
    },    
    getOrgs() { // 获取所在企业及其下级
      getCurrOrgWidthSub().then(({data}) => {
        this.orgs = data.data;
      })
    },
    toDeleteRole(id) { // 删除角色
      this.$confirm('确定要删除此角色？一旦删除，无法找回！', '提示').then(_ => {
        deleteEnterpriseRole(id).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
        }).catch(_ => {})
      }).catch(_ => {})
    },
    load(role, treeNode, resolve) {
      getUserListByRoleId(role.id).then(({data}) => {
        resolve(data.data);
      }).catch(_ => resolve([]));
    },
    toAddRoleUser(role) {
      this.role = role;
      this.$refs.userAdd.show();
    },
    toDeleteRoleUser(userRoleId) {
      this.$confirm('确定要删除此人？', '提示').then(_ => {
        deleteUserRoleById(userRoleId).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
        });
      }).catch(_ => {});
    }
  }
})
</script>